import * as React from "react";
import { Box } from "lucide-react";
import { PanelSectionHeader } from "@/taskpane/shared/components/panel-layout";

interface BlocksHeaderProps {
  blocksCount: number;
}

const BlocksHeader: React.FC<BlocksHeaderProps> = ({ blocksCount }) => {
  return (
    <PanelSectionHeader
      icon={Box}
      title="Document Blocks"
      count={blocksCount}
      countLabel="blocks"
      className="mb-4"
    />
  );
};

export default BlocksHeader;
